import styled from 'styled-components'

import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Description = styled.div<{ $mode: ThemeModeType }>`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.light};
    color: ${(props) => (props.$mode === 'Light' ? props.theme.color.black : props.theme.color.white)};
    margin-bottom: 16px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayM};
    }

    ul {
        list-style-type: none;

        > br {
            display: none;
        }

        li {
            padding-left: 25px;
            position: relative;
            margin-bottom: 16px;
            ${(props) => props.theme.typo.bodyM};
            ${(props) => props.theme.fontWeight.regular};

            @media ${(props) => props.theme.query.min.tablet} {
                ${(props) => props.theme.typo.bodyL};
            }

            ::after {
                position: absolute;
                left: 6px;
                top: 11px;
                content: '';
                z-index: 2;
                height: 7px;
                width: 3px;
                border-bottom: 2px solid ${(props) => props.theme.color.white};
                /*! @noflip */
                border-right: 2px solid ${(props) => props.theme.color.white};
                transform: rotate(45deg);
            }

            ::before {
                position: absolute;
                left: 0;
                top: 8px;
                content: '';
                z-index: 1;
                height: 16px;
                width: 17px;
                border-radius: 17px;
                background-color: ${(props) => props.theme.color.b600};
            }
        }
    }
`
